// extracted by mini-css-extract-plugin
export var sider = "sider-module--sider--4dcce";
export var siderMenu = "sider-module--siderMenu--ce6bd";